import URLHelper from "./URLHelper";
import Firehose from "./LogLibraries/Firehose";
import xAPIHelper from "./LogLibraries/xApiHelper";
import fetchContentProps from "../players/utils/fetchContentProps";
import { GlobalResourceManager } from "./GlobalResourceManager";
import * as xAPIInterfaces from "./LogLibraries/xAPIInterfaces";
import SessionStorageHelper from "./SessionStorageHelper";
import LogHelper from "./LogHelper";
import LoginInitialize from "./LoginInitialize";

export default {
  LogHelper,
  URLHelper,
  LogLibraries: { Firehose, xAPIHelper, xAPIInterfaces },
  ContentPropsHelper: { fetchContentProps },
  GlobalResourceManager,
  SessionStorageHelper,
  LoginInitialize
};
